import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=95c0d03c&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"
import style0 from "./Order.vue?vue&type=style&index=0&id=95c0d03c&prod&lang=scss&scoped=true"
import style1 from "./Order.vue?vue&type=style&index=1&id=95c0d03c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c0d03c",
  null
  
)

export default component.exports